import { useId } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = {
  size?: Unit;
  className?: string;
  colors?: string[];
};
export const Raffle = ({
  size = 4,
  className,
  colors = ['#9A45FF', '#03FFBD'],
}: Props) => {
  const id = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      className={className}
    >
      <g clipPath={`url(#${id}-clip)`}>
        <path
          d="M12.2422 8.9209C14.6677 8.92115 16.6346 10.8876 16.6348 13.3135C16.6348 14.9725 15.7142 16.4169 14.3564 17.1641C15.9403 17.768 17.1809 19.031 17.7178 20.6025C18.3195 19.6778 19.3849 19.0626 20.5986 19.0625C22.4769 19.0625 23.9998 20.535 24 22.3506H0C0.000160055 20.5351 1.52328 19.0627 3.40137 19.0625C4.86759 19.0625 6.11797 19.9598 6.5957 21.2168C6.99213 19.3628 8.34156 17.8447 10.127 17.1641C8.76919 16.4169 7.84863 14.9729 7.84863 13.3135C7.84881 10.8878 9.81649 8.9209 12.2422 8.9209ZM3.74023 13.5361C5.12561 13.5361 6.24887 14.6596 6.24902 16.0449C6.24893 17.4303 5.12564 18.5537 3.74023 18.5537C2.35487 18.5537 1.23154 17.4303 1.23145 16.0449C1.2316 14.6596 2.35491 13.5362 3.74023 13.5361ZM20.9375 13.5361C22.3228 13.5362 23.4461 14.6596 23.4463 16.0449C23.4462 17.4303 22.3229 18.5537 20.9375 18.5537C19.5521 18.5537 18.4288 17.4303 18.4287 16.0449C18.4289 14.6596 19.5521 13.5361 20.9375 13.5361ZM5.62988 8.15234H3.55762V10.1709H1.99609V6.5918H5.62988V8.15234ZM22.0146 10.1709H20.4531V8.15234H18.3818V6.5918H22.0146V10.1709ZM14.7188 3.49121L18.0068 2.25977L15.8174 7.66699H8.66504L6.47559 2.25977L9.63672 3.49121L12.2412 -0.00195312L14.7188 3.49121Z"
          fill={`url(#${id}-gradient)`}
        />
      </g>
      <defs>
        <linearGradient
          id={`${id}-gradient`}
          x1="12"
          y1="-0.00195246"
          x2="12"
          y2="22.3506"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
        <clipPath id={`${id}-clip`}>
          <rect width="24" height="22.3519" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
